import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const CategoriesItem = ({ categoryIndex, name, path }) => {
  return (
    <div key={categoryIndex} className={`col-6 col-md-4 px-1 py-1 pos-category pos-${categoryIndex}`}>
      <Link
        to={path}
        title={name}
      >
        <div className='box-category row align-items-center mx-0'>
          <div className='col px-1 px-md-2'>
            <h3>{name}</h3>
          </div>
        </div>
      </Link>
    </div>
  )
}

CategoriesItem.propTypes = {
  categoryIndex: PropTypes.number,
  name: PropTypes.string,
  path: PropTypes.string
}

export default CategoriesItem



// WEBPACK FOOTER //
// ./src/Catalog/Showcase/CategoriesShowcase/CategoriesItem.js